const {KitModule, registerModule} = window;

class SearchToggle extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
  }

  setVars() {
    this.searchIsOpen = false;
    this.breakpoint = this.$element.getAttribute('data-breakpoint');
    this.openInModal = this.$element.hasAttribute('data-micromodal-trigger');
  }

  bindEvents() {
    this.$element.addEventListener('click', this);

    // listen for mobile nav menu toggle
    window.addEventListener('menulabelclicked', this);
    window.addEventListener('searchescape', this);
  }

  onclick() {
    this.searchIsOpen = !this.searchIsOpen;

    // dispatch event
    if (this.searchIsOpen) {
      this.dispatchEvent('searchopen');
    } else {
      this.dispatchEvent('searchclose');
    }

    // update UI
    if (!this.openInModal) {
      document.documentElement.classList.toggle('search-is-open');
      this.$element.classList.toggle('is-visible');
    }
  }

  onsearchescape() {
    if (this.searchIsOpen) {
      this.$element.click();
    }
  }

  onmenulabelclicked() {
    if (this.searchIsOpen) {
      this.$element.click();
    }
  }

  dispatchEvent(eventName) {
    const event = new Event(eventName);
    window.dispatchEvent(event);
  }
}


registerModule('SearchToggle', SearchToggle);
